export default __webpack_public_path__ + "static/main-cup-dark-green-2daf245c791ad5d3611cebd327e955ed.png";